<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-container
            class="fluid grid-list-xl"
            style="height: 100%;"
    >
        <v-layout class="row wrap">
            <v-flex class="xs12 sm9 md9 lg9" style="padding-top:0px; padding-bottom: 0px;">
                <table>
                    <tr>
                        <td>
                        <span style="font-weight: bold; font-size: 17px;">등록 대기 차량 - </span>
                <span v-show="parkinglots.length <= 1">
                    {{parkinglot_selected.Name}}
                </span>
                        </td>
                        <td>
                            <v-select
                        v-show="parkinglots.length > 1"
                        :items="parkinglots"
                        v-model="parkinglot_selected"
                        item-text="Name"
                        return-object
                        @change="
                          $cookies.set('parkinglotidx', parkinglot_selected.ParkingLotIDX);
                          getList();"
                        class="hide-messages"
                ></v-select>
                        </td>
                    </tr>
                </table>
            </v-flex>
            <v-flex class="xs8 offset-xs4 sm6 offset-sm6 md3 offset-md0 lg3" style="padding-top:0px; padding-bottom: 0px;">
            <v-text-field
                        placeholder="search"
                        solo
                        v-model="search"
                        prepend-inner-icon="search"
                        label="Search"
                        clearable
                        class="hide-messages"
                ></v-text-field>
            </v-flex>
        </v-layout>

        <v-layout class="row wrap">
            <v-flex class="xs12 sm12 md12 lg12">
                <v-data-table
                        :headers="headers"
                        :items="periodiccars"
                        :search="search"
                        hide-actions
                        class="elevation-1"
                >
                    <template slot="items" slot-scope="items">
                        <td class="text-xs-center">{{ items.item.PeriodicCarIDX }}</td>
                        <td class="text-xs-center">{{ items.item.CarNumber }}</td>
                        <td class="text-xs-center">{{ items.item.Name }}</td>
                        <td class="text-xs-center">{{ items.item.Tel }}</td>
                        <td class="text-xs-center">{{ items.item.Model }}</td>
                        <td class="text-xs-center">{{ items.item.Description }}</td>
                        <td class="text-xs-center">{{ items.item.Charge }}</td>
                        <td class="text-xs-center">{{ items.item.LastChargedYearMonth }}</td>
                        <td class="text-xs-center" style="width: 290px;">
                            <v-btn color="success" @click="setRegistered(items.item)" style="width: 80px;">차량 등록</v-btn>
<!--                            <v-btn color="success" @click="-->
<!--                            payment_dialog = true;-->
<!--                            payment_valid = true;-->
<!--                            payment_isrefund = true;-->
<!--                            payment_item = tool_app.copy(items.item);-->
<!--                             ">환불</v-btn>-->
                            <v-btn color="success" @click="
                            edit_dialog = true;
                            edit_valid = true;
                            edit_new = false;
                            edit_item = tool_app.copy(items.item); " style="width: 80px;">수정</v-btn>
                            <v-btn color="success" @click="item_delete(items.item)" style="width: 80px;">삭제</v-btn>
                        </td>
                    </template>
                </v-data-table>
            </v-flex>
        </v-layout>

        <v-btn class="v-btn v-btn--floating v-btn--bottom v-btn--fixed v-btn--right pink" round style="width: 60px; height: 60px; margin-right:15px; "
                @click="edit_dialog = true; edit_valid = true; edit_new = true; edit_item = {}; " >
            <v-icon>add</v-icon>
        </v-btn>

<!--        <v-dialog v-model="parkinglots_dialog" persistent max-width="400px">-->
<!--            <v-card>-->
<!--                <v-card-text>-->
<!--                  <v-btn-->
<!--                          v-for="parkinglot in parkinglots"-->
<!--                          :key="parkinglot.IDX"-->
<!--                          class="success"-->
<!--                          @click="-->
<!--                          parkinglot_selected = parkinglot;-->
<!--                          parkinglot_selected_idx = parkinglot.IDX;-->
<!--                          parkinglots_dialog = false; getList();"-->
<!--                  >-->
<!--                      {{ parkinglot.Name }}-->
<!--                  </v-btn>-->
<!--                </v-card-text>-->
<!--            </v-card>-->
<!--        </v-dialog>-->

        <v-dialog v-model="edit_dialog" persistent max-width="400px">
            <v-card>
                <v-card-text>
                    <v-container grid-list-md>
                        <span style="font-weight: bold; font-size: 17px;" v-if="edit_new === true">등록 대기 차량 생성</span>
                        <span style="font-weight: bold; font-size: 17px;" v-if="edit_new === false">등록 대기 차량 수정</span>
                        <v-form ref="edit_form"
                                v-model="edit_valid"
                                lazy-validation>
                            <v-layout wrap>
                                <v-flex xs12>
                                    <v-text-field label="차량번호"
                                                  v-model="edit_item.CarNumber"
                                                  :rules="edit_name_rules"></v-text-field>
                                </v-flex>
                                <v-flex xs12>
                                    <v-text-field label="Name"
                                                  v-model="edit_item.Name"
                                                  :rules="edit_name_rules"></v-text-field>
                                </v-flex>
                                <v-flex xs12>
                                    <v-text-field label="Tel."
                                                  v-model="edit_item.Tel"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs12>
                                    <v-text-field label="차종"
                                                  v-model="edit_item.Model"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs12>
                                    <v-text-field label="비고"
                                                  v-model="edit_item.Description"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs12>
                                    <v-text-field label="이용료 (VAT 포함)"
                                                  v-model="edit_item.Charge"
                                                  :rules="edit_number_rules"
                                    ></v-text-field>
                                </v-flex>
                            </v-layout>
                        </v-form>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" flat @click="edit_dialog = false">취소</v-btn>
                    <v-btn color="blue darken-1" flat @click="edit_submit()">저장하기</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
  import tool_app from '../../utils/tool_app';
  import tool_aws from '../../utils/tool_aws';

  function lg (...args) { tool_app.lg('PeriodicCarStandByManage] ', ...args); }

  let comp = null;
  export default {
    components: { },
    data () {
      return {
        tool_app: tool_app,

        parkinglots_dialog: false,
        parkinglot_selected: {},
        parkinglot_selected_idx: 0,

        edit_dialog: false,
        edit_valid: true,
        edit_new: false,
        edit_item: {},
        edit_name_rules: [
          v => !!v || '입력해주세요..',
        ],
        edit_address_rules: [
          v => !!v || '입력해주세요..',
        ],
        edit_tel_rules: [
          v => !!v || '입력해주세요..',
        ],
        edit_number_rules: [
          v => !!v || '입력해주세요..',
          v => !!(tool_app.isNumeric(v)) || '숫자만 입력해주세요..',
        ],
        edit_exist_rules: [
          v => !!v || '선택해주세요..',
        ],

        parkinglots: [
        ],

        search: '',
        reservations: [],

        headers: [
          {text: 'No.', value: 'PeriodicCarIDX', align:'center',},
          {text: '차량번호', value: 'CarNumber', align:'center',},
          {text: 'Name', value: 'Name', align:'center',},
          {text: 'Tel.', value: 'Tel', align:'center',},
          {text: '차종', value: 'Model', align:'center',},
          {text: '비고', value: 'Description', align:'center',},
          {text: '이용료 (VAT 포함)', value: 'Charge', align:'center',},
          {text: '마지막 결제월', value: 'LastChargedYearMonth', align:'center',},
          {text: '', value: '', sortable: false },
        ],
      }
    },
    created: async function () {
      lg('created 1');
      comp = this;
      comp.payment_years = [];
      let d = new Date();
      comp.payment_years.push(d.getFullYear() - 1)
      comp.payment_years.push(d.getFullYear())
      comp.payment_years.push(d.getFullYear() + 1)
      comp.payment_years.push(d.getFullYear() + 2)
      comp.payment_years.push(d.getFullYear() + 3)

      tool_app.api(comp, 'SELECT * FROM T_ParkingLot WHERE IsExist = true;',
        [])
        .setShowProgressDialog()
        .send()
        .then(async (value) => {
          lg('getList 2 value:', value.data.results);
          let session = await tool_aws.getCurrentSession();
          // lg('getList 3 session:\n'+ JSON.stringify(session));
          if(session.idToken.payload['custom:permission'] === '총괄관리자') {
            comp.parkinglots = value.data.results;

            let pidx = comp.$cookies.get('parkinglotidx');
            lg('getList 4 pidx:', pidx);
            let s = false;
            if(tool_app.isNumber(pidx) === false) {
              comp.parkinglots.forEach((value1, index, array) => {
                lg('getList 4 pidx:', pidx, ' value1.ParkingLotIDX:', value1.ParkingLotIDX);
                if(value1.ParkingLotIDX === Number(pidx)) {
                  lg('getList 4 pidx:', pidx, ' value1.ParkingLotIDX:', value1.ParkingLotIDX);
                  s = true;
                  comp.parkinglot_selected = value1;
                  comp.getList();
                }
              });
            }

            if(s === false) {
              comp.parkinglots_dialog = true;
            }
          }
          else {
            let parkinglots = value.data.results;
            parkinglots.forEach((value1, index, array) => {
              if(value1.ParkingLotIDX === Number(session.idToken.payload['custom:m_parkinglotidx'])) {
                comp.parkinglot_selected = value1;
                // comp.parkinglot_selected_idx = value1.IDX;
                comp.parkinglots = [ comp.parkinglot_selected ];
                comp.getList();
              }
            });
          }
        })
        .catch((reason) => {
          tool_app.ex(new Error(JSON.stringify(reason, null, 2)));
        });
    },
    methods: {
      async item_delete(item) {
        lg('item_delete 1 item:', tool_app.showObject(item));
        // comp.$dialog.confirm(item.Name + '을 정말 삭제하시겠습니까?')
        // let res = await this.$dialog.confirm({
        //   text: 'Do you realy want to delete item?',
        //   title: 'Warning',
        //   actions: {
        //     false: {
        //       text: 'No',
        //       color: 'vuetifydialog-cancel',
        //     },
        //     true: {
        //       color: 'vuetifydialog-ok',
        //       text: 'Yes I do',
        //       handle: () => {
        //         return new Promise(resolve => {
        //           setTimeout(resolve, 3000)
        //         })
        //       }
        //     }
        //   }
        // });

        // comp.$dialog.confirm({
        //   text: 'Do you really want to exit?',
        //   title: 'Warning',
        //   actions: {
        //     false: 'No',
        //     true: {
        //       color: 'red',
        //       text: 'Yes I do',
        //       handle: () => {
        //         return new Promise(resolve => {
        //           // setTimeout(resolve, 3000)
        //           lg('item_delete confirm');
        //           tool_app.api(this,`
        //                 UPDATE T_PeriodicCar
        //                 SET IsExist = false
        //                 WHERE IDX = ?
        //                 `, [ item.IDX, ])
        //             .setShowProgressDialog()
        //             .send()
        //             .then((value) => {
        //               lg('item_delete 3 value:', value);
        //               comp.getList();
        //             })
        //             .catch((reason => {
        //               tool_app.ex(reason);
        //               this.$dialog.alert(JSON.stringify(reason, null, 2));
        //             }));
        //         })
        //       }
        //     }
        //   }
        // })


        comp.$dialog.confirm(item.Name + '을 정말 삭제하시겠습니까?')
          .then(async (dialog) => {
            lg('item_delete confirm');
            tool_app.api(this,`
            UPDATE T_PeriodicCar
            SET IsExist = false
            WHERE PeriodicCarIDX = ?
            `, [ item.PeriodicCarIDX, ])
              .setShowProgressDialog()
              .send()
              .then((value) => {
                lg('item_delete 3 value:', value);
                comp.getList();
              })
              .catch((reason) => {
                tool_app.ex(reason);
                this.$dialog.alert(JSON.stringify(reason, null, 2));
              });
          });
      },
      async edit_submit () {
        lg('edit_submit 1 ');
        if (this.edit_dialog && this.$refs.edit_form.validate()) {
          lg('edit_submit 2 this.edit_dialog:', this.edit_item.Name);

          if(this.edit_new) {
            tool_app.api(this, `
            INSERT INTO T_PeriodicCar
            (ParkingLotIDX, CarNumber, Name,
            Tel, Model, Description, Charge,
            IsStandBy, IsExist, DateTime_Created, DateTime_Modified) VALUES
            (?, ?, ?,
            ?, ?, ?, ?,
            true, true, NOW(), NOW())
            `, [ this.parkinglot_selected.ParkingLotIDX, this.edit_item.CarNumber, this.edit_item.Name,
              this.edit_item.Tel, this.edit_item.Model, this.edit_item.Description, this.edit_item.Charge, ])
              .setShowProgressDialog()
              .send()
              .then((value) => {
                lg('edit_submit 3 value:', value);
                comp.edit_dialog = false;
                comp.getList();
              })
              .catch((reason) => {
                tool_app.ex(reason);
                // TODO
                comp.$dialog.alert(JSON.stringify(reason, null, 2));
              });
          }
          else {
            tool_app.api(this,`
            UPDATE T_PeriodicCar
            SET CarNumber = ?, Name = ?, Tel = ?, Model = ?, Description = ?, Charge = ?, DateTime_Modified = NOW()
            WHERE PeriodicCarIDX = ?
            `, [ this.edit_item.CarNumber, this.edit_item.Name, this.edit_item.Tel, this.edit_item.Model, this.edit_item.Description, this.edit_item.Charge,
              this.edit_item.PeriodicCarIDX, ])
              .setShowProgressDialog()
              .send()
              .then((value) => {
                lg('edit_submit 3 value:', value);
                comp.edit_dialog = false;
                comp.getList();
              })
              .catch((reason) => {
                tool_app.ex(reason);
                comp.$dialog.alert(JSON.stringify(reason, null, 2));
              });
          }
        }
      },
      async setRegistered(item) {
        lg('setRegistered 1 item:', item);

        comp.$dialog.confirm(item.CarNumber + '을 차량등록하시겠습니까?')
          .then(async (dialog) => {
            lg('setRegistered 2 confirm');
            tool_app.api(this,`
            UPDATE T_PeriodicCar
            SET IsStandBy = false
            WHERE PeriodicCarIDX = ?
            `, [ item.PeriodicCarIDX, ])
              .setShowProgressDialog()
              .send()
              .then((value) => {
                lg('setRegistered 3 value:', value);
                comp.getList();
              })
              .catch((reason) => {
                tool_app.ex(reason);
                this.$dialog.alert(JSON.stringify(reason, null, 2));
              });
          });
      },
      async getList() {
        lg('getList 1 ', comp.parkinglot_selected);
        tool_app.api(comp, 'SELECT * FROM T_PeriodicCar WHERE IsStandBy = true AND IsExist = true AND ParkingLotIDX = ?;',
          [ comp.parkinglot_selected.ParkingLotIDX, ])
          .send()
          .then((value) => {
            // lg('getList 2 value:', value);
            lg('getList 2 value:', value.data.results);
            comp.periodiccars = value.data.results;
          })
          .catch((reason) => {
            tool_app.ex(new Error(JSON.stringify(reason, null, 2)));
          });
      },
    }
  }

</script>
